import { cn } from './utils'

export type ProcessingVariant = 'local' | 'server' | 'local-first'

export interface ProcessingBadgeProps {
  variant: ProcessingVariant
  className?: string
  /** Override the badge text (defaults to Russian). */
  label?: string
  /** Override the tooltip text (defaults to Russian). */
  title?: string
}

const DEFAULT_LABEL: Record<ProcessingVariant, string> = {
  local: 'Локально',
  server: 'На сервере',
  'local-first': 'Локально*',
}

const DEFAULT_TITLE: Record<ProcessingVariant, string> = {
  local: 'Файл обрабатывается прямо в браузере и не отправляется на сервер',
  server: 'Файл отправляется на сервер для обработки',
  'local-first':
    'По умолчанию обрабатывается в браузере. Опционально можно отправить на сервер для более глубокого сжатия.',
}

const CHIP_CLASS: Record<ProcessingVariant, string> = {
  local:
    'border-green-200 bg-green-50 text-green-700 dark:border-green-500/30 dark:bg-green-500/10 dark:text-green-200',
  server: 'border-border bg-muted text-muted-foreground',
  'local-first':
    'border-sky-200 bg-sky-50 text-sky-700 dark:border-sky-500/30 dark:bg-sky-500/10 dark:text-sky-200',
}

const DOT_CLASS: Record<ProcessingVariant, string> = {
  local: 'bg-green-600 dark:bg-green-300',
  server: 'bg-muted-foreground/60',
  'local-first': 'bg-sky-600 dark:bg-sky-300',
}

export function ProcessingBadge({ variant, className, label, title }: ProcessingBadgeProps) {
  return (
    <span
      title={title ?? DEFAULT_TITLE[variant]}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium',
        CHIP_CLASS[variant],
        className,
      )}
    >
      <span
        aria-hidden="true"
        className={cn('h-1.5 w-1.5 rounded-full', DOT_CLASS[variant])}
      />
      {label ?? DEFAULT_LABEL[variant]}
    </span>
  )
}
